import { useFormSchema } from "src/api/hooks/useFormSchema";

export const ToggleWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;

  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`toggle-container container`}>
      <input
        type="checkbox"
        className={`input-toggle`}
        checked={value || false}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
      />
    </div>
  );
};
